import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';
import {Kmlmanager} from 'src/app/shared/kmlmanager';
import { Google_map } from 'src/app/shared/google_map';

@Component({
  selector: 'app-kmltest',
  templateUrl: './kmltest.component.html',
  styleUrls: ['./kmltest.component.css']
})
export class KmltestComponent extends BaseComponent implements OnInit {
  @ViewChild('pagemap', { static: true }) mapElement: any = {};
  kmlfile: any = {}
  KML: any = {}
  scenariolayout: any = {}
  kmlFileDataAsJson: any = ""
  fileName: any = ""
  input: FormData = new FormData()
  res: any = {}

  folder: any = {}
  Placemarks: any = {}
  google_map: Google_map
  constructor(injector: Injector) { super(injector) }

  ngOnInit(): void {
  }

  receiveFileAsString($event: any) {
    this.fileName = $event.fileName;
    const jsonstring = $event.fileData;
    this.kmlFileDataAsJson = JSON.parse($event.fileData);
    this.folder = this.kmlFileDataAsJson.kml.Document.Folder;
    this.Placemarks = this.folder[0].Placemark;

    this.KML = new Kmlmanager($event.fileData)
    this.scenariolayout = this.KML.scenariolayout;
    let a = 5;
  }

  createPolygon() {
    this.google_map = new Google_map()
    let latlng = this.scenariolayout.center
    this.google_map.init(this.mapElement.nativeElement, latlng, 13)
    this.google_map.setMarker(latlng, "Center");
    this.scenariolayout.contours.forEach((p: any,i: number) => {
      let color = this.scenariolayout.contourdefinitions[i].color;
      this.google_map.addPolygon(p,color)
    })
  }

}
